import http from "../common/services/httpService";
import { AxiosResponse } from "axios";
import queryString from "query-string";

import { Nomenclature } from "../common/components/mui-extended/SelectExtended";

const apiEndpoint = "/notary";

const getActiveNotaryIdByNumberAsync = async (number: number): Promise<AxiosResponse<number | null>> => {
  return await http.get<number | null>(`${apiEndpoint}/activeNotaryIdByNumber?number=${number}`);
};

const getNotaries = async (
  offset: number = 0,
  limit: number = Number.MAX_SAFE_INTEGER,
  keyword: string = ""
): Promise<AxiosResponse<Array<Nomenclature>>> => {
  return await http.get<Array<Nomenclature>>(
    `${apiEndpoint}/nomenclature/search?offset=${offset}&limit=${limit}&keyword=${keyword}`
  );
};

const getNotariesByIds = async (ids: Array<number>): Promise<AxiosResponse<Array<Nomenclature>>> => {
  const queryStringIds = queryString.stringify({ ids }, { arrayFormat: "index" });
  return await http.get<Array<Nomenclature>>(`${apiEndpoint}/nomenclature/init?${queryStringIds}`);
};

export default {
  getActiveNotaryIdByNumberAsync,
  getNotaries,
  getNotariesByIds,
};
